function HomePage() {
  return <p>/home</p>;
}
export default HomePage;
